import { Injectable, signal } from '@angular/core';
import { CaseRequest } from '@shared/models';

@Injectable({
  providedIn: 'root'
})
export class CaseDataService {
  readonly #caseRequests = signal<CaseRequest[]>([]);

  readonly caseRequests = this.#caseRequests.asReadonly();

  updateCaseRequests(requests: CaseRequest[]) {
    this.#caseRequests.set(requests);
  }

  getCaseRequestById(id: string): CaseRequest | undefined {
    return this.#caseRequests().find(request => request.id === id);
  }

  addCaseRequest(request: CaseRequest) {
    this.#caseRequests.update(requests => [...requests, request]);
  }

  removeCaseRequest(id: string) {
    this.#caseRequests.update(requests => requests.filter(request => request.id !== id));
  }
}
